import axios from 'axios';
import {
  CompanyEvolutionApi,
  NotificationRule,
  RuleEvent,
} from './types';

const API_URL = process.env.REACT_APP_API_URL;

export async function listRules(filter: { scope?: 'global' | 'company'; company_id?: number; enabled?: boolean }): Promise<NotificationRule[]> {
  const { data } = await axios.get<{ data: NotificationRule[] }>(`${API_URL}/notifications/rules`, { params: filter });
  return data.data ?? [];
}

export async function getRule(id: number): Promise<NotificationRule> {
  const { data } = await axios.get<{ data: NotificationRule }>(`${API_URL}/notifications/rules/${id}`);
  return data.data;
}

export async function createRule(body: Partial<NotificationRule> & { triggers: any[]; actions: any[] }): Promise<NotificationRule> {
  const { data } = await axios.post<{ data: NotificationRule }>(`${API_URL}/notifications/rules`, body);
  return data.data;
}

export async function updateRule(id: number, body: Partial<NotificationRule>): Promise<NotificationRule> {
  const { data } = await axios.put<{ data: NotificationRule }>(`${API_URL}/notifications/rules/${id}`, body);
  return data.data;
}

export async function deleteRule(id: number): Promise<void> {
  await axios.delete(`${API_URL}/notifications/rules/${id}`);
}

export async function listRuleEvents(rule_id: number, limit = 50): Promise<RuleEvent[]> {
  const { data } = await axios.get<{ data: RuleEvent[] }>(`${API_URL}/notifications/rules/${rule_id}/events`, { params: { limit } });
  return data.data ?? [];
}

export async function listCompanyEvents(company_id: number, limit = 50): Promise<RuleEvent[]> {
  const { data } = await axios.get<{ data: RuleEvent[] }>(`${API_URL}/notifications/companies/${company_id}/events`, { params: { limit } });
  return data.data ?? [];
}

export async function getEvolutionConfig(company_id: number): Promise<CompanyEvolutionApi | null> {
  const { data } = await axios.get<{ data: CompanyEvolutionApi | null }>(`${API_URL}/notifications/evolution/${company_id}`);
  return data.data ?? null;
}

export async function upsertEvolutionConfig(body: {
  company_id: number;
  base_url: string;
  instance_name: string;
  api_key: string;
  enabled?: boolean;
}): Promise<CompanyEvolutionApi> {
  const { data } = await axios.put<{ data: CompanyEvolutionApi }>(`${API_URL}/notifications/evolution`, body);
  return data.data;
}
